var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { createMemoryHistory } from 'history';
import { Resolver } from './Resolver';
import { Router } from './Router';
import { createOrPassthroughObserver } from './Observable';
import { createCurrentRouteObservable } from './CurrentRouteObservable';
import { createURLDescriptor } from './URLTools';
export function createMemoryNavigation(options) {
  return new MemoryNavigation(options);
}

var MemoryNavigation =
/** @class */
function () {
  function MemoryNavigation(options) {
    this.history = createMemoryHistory({
      initialEntries: [createURLDescriptor(options.url).href]
    });
    this.resolver = new Resolver();
    this.pages = options.pages;
    this.basename = options.basename;
    this.router = new Router(this.resolver, {
      rootContext: options.context,
      pages: this.pages,
      basename: this.basename
    });
    this.currentRouteObservable = createCurrentRouteObservable({
      history: this.history,
      router: this.router
    });
  }

  MemoryNavigation.prototype.dispose = function () {
    this.currentRouteObservable.dispose();
    delete this.currentRouteObservable;
    delete this.router;
    delete this.resolver;
    delete this.pages;
  };

  MemoryNavigation.prototype.setContext = function (context) {
    this.router = new Router(this.resolver, {
      rootContext: context,
      pages: this.pages,
      basename: this.basename
    });
    this.currentRouteObservable.setRouter(this.router);
  };

  MemoryNavigation.prototype.getCurrentValue = function () {
    var route = this.currentRouteObservable.getValue();
    return {
      route: route,
      url: route.url,
      history: this.history,
      router: this.router,
      onRendered: noop
    };
  };

  MemoryNavigation.prototype.getSteadyValue = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.currentRouteObservable.getSteadyRoute().then(function (route) {
          return {
            route: route,
            url: route.url,
            history: _this.history,
            router: _this.router,
            onRendered: noop
          };
        })];
      });
    });
  };

  MemoryNavigation.prototype.steady = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.getSteadyValue()];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * If you're using code splitting, you'll need to subscribe to changes to
   * the snapshot, as the route may change as new code chunks are received.
   */


  MemoryNavigation.prototype.subscribe = function (onNextOrObserver, onError, onComplete) {
    var navigationObserver = createOrPassthroughObserver(onNextOrObserver, onError, onComplete);
    var mapObserver = new MapObserver(navigationObserver, this);
    return this.currentRouteObservable.subscribe(mapObserver);
  };

  return MemoryNavigation;
}();

export { MemoryNavigation };

var noop = function noop() {};

var MapObserver =
/** @class */
function () {
  function MapObserver(observer, navigation) {
    this.observer = observer;
    this.navigation = navigation;
  }

  MapObserver.prototype.next = function (route) {
    this.observer.next({
      route: route,
      url: route.url,
      history: this.navigation.history,
      router: this.navigation.router,
      onRendered: noop
    });
  };

  MapObserver.prototype.error = function (errorValue) {
    if (this.observer.error) {
      this.observer.error(errorValue);
    }
  };

  return MapObserver;
}();